import {Clock3} from "lucide-react";
import {margin, rupiah} from "./Common";

export function StockAge({days}) {
  return <span className="eh-stock-age" data-testid="inventory-aging"><Clock3 size={13}/>{days == null ? "Umur stok belum diketahui" : `Umur stok ${days.toLocaleString("id-ID")} hari`}</span>;
}

export function StockProfit({item, visible}) {
  if (!visible) return null;
  if (item.internal_only) return <div className="eh-stock-profit muted">Pelengkap gratis · modal masuk HPP saat diberikan</div>;
  const known = !item.cost_pending && item.cost != null && Number(item.price) > 0;
  if (!known) return <div className="eh-stock-profit muted" data-testid="inventory-margin-unknown">Keuntungan belum dapat dihitung<small>{item.cost_pending || item.cost == null ? "Modal belum dibukukan / diketahui" : "Harga jual belum diisi"}</small></div>;
  const profit = Number(item.price) - Number(item.cost), loss = profit < 0;
  const percent = Number(item.cost) > 0 ? `${(profit / Number(item.cost) * 100).toLocaleString("id-ID", {maximumFractionDigits:1})}%` : null;
  return <div className={`eh-stock-profit ${loss ? "loss" : profit > 0 ? "gain" : "muted"}`} data-testid={`inventory-margin-${item.id}`} title="Keuntungan dari modal = (harga jual − modal) ÷ modal × 100%. Margin penjualan memakai harga jual sebagai pembagi. Estimasi sebelum biaya pelengkap saat transaksi.">
    <b>{loss ? "Potensi rugi" : profit > 0 ? "Potensi untung" : "Impas"}{percent != null ? ` ${percent} dari modal` : ""}</b>
    <small>{rupiah(profit)} / {item.kind === "lot" ? "pcs" : "unit"}</small>
    {percent == null && <small>Persentase dari modal tidak dihitung: modal Rp0</small>}
    <small>Margin penjualan {margin(item.cost,item.price)}</small>
  </div>;
}
